import { render, staticRenderFns } from "./area_select.vue?vue&type=template&id=1cd8ffac&scoped=true"
import script from "./area_select.vue?vue&type=script&lang=js"
export * from "./area_select.vue?vue&type=script&lang=js"
import style0 from "./area_select.vue?vue&type=style&index=0&id=1cd8ffac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8ffac",
  null
  
)

export default component.exports